<template>
    <c-dialog ref="dialog" width="500" height="420" @resolve="editHandle">
        <c-form ref="form" unit-width="80%">
            <c-form-item :label="dialogType === 'receipt' ? '客户' : '供应商'" required>
                <c-select name="target_id" async @search="searchTarget(dialogType === 'receipt'?'SALE_CUSTOMER':'SUPPLIER',arguments[0], arguments[1])"></c-select>
            </c-form-item>

            <c-form-item :label="dialogType === 'receipt' ? '预收金额' : '预付金额'" required>
                <c-input name="amount" class="m-price-input" type="number" decimal="2"
                         :range="[0.01, 9999999]"
                         placeholder="请输入金额" append-text="元"></c-input>
            </c-form-item>

            <c-form-item label="收款日期" required>
                <c-datetime name="receipt_date" type="date" format="yyyy-MM-dd"></c-datetime>
            </c-form-item>

            <c-form-item label="备注">
                <c-input type="textarea" name="remark" maxlength="500"  placeholder="请输入备注说明（选填）"></c-input>
            </c-form-item>
        </c-form>
    </c-dialog>
</template>

<script>
export default {
    name: 'advanceAddDialog',
    props: {
        dialogType: {
            type: String,
            default: 'receipt'  // receipt-预收款 / payment-预付款
        }
    },
    data() {
        return {
            accountOptions: [
                { name: '银行对公账户', value: 1 },
                { name: '微信', value: 2 },
                { name: '支付宝', value: 3 },
                { name: '现金', value: 4 }
            ]
        }
    },
    methods: {
        /** 打开弹窗 */
        open() {
            this.$refs.form.clear();
            let title = this.dialogType === 'receipt' ? '新增预收款' : '新增预付款';
            this.$refs.dialog.open({ title: title });
        },

        /*******搜索采购供应商*****************/
        searchTarget(code,keyword, resolve){
            this.request({
                url:'/system/options',
                data: {
                    options_code:code,
                    keyword:keyword
                },
                success:data => {
                    resolve(data);
                }
            })
        },

        /** 提交处理 */
        editHandle(stop, next) {
            stop();
            let url = this.dialogType === 'receipt'
                ? '/advance/receipt/payment/add/receipt'
                : '/advance/receipt/payment/add/payment';
            let amountField = this.dialogType === 'receipt' ? '预收金额' : '预付金额';
            let targetField = this.dialogType === 'receipt' ? '客户' : '供应商';

            let rule = {
                target_id: '请选择' + targetField,
                amount: [{
                    type: 'empty',
                    message: '请输入' + amountField
                }, {
                    type: 'function',
                    fun: (value) => value > 0,
                    message: amountField + '必须大于0'
                }],
                receipt_date: '请选择收款日期'
            };

            this.$refs.form.submit({
                url: url,
                rule: rule,
                success: (data, res) => {
                    next();
                    let msg = this.dialogType === 'receipt' ? '预收款新增成功' : '预付款新增成功';
                    this.$message({ message: msg, type: 'success' });
                    this.$emit('resolve');
                }
            });
        }
    }
}
</script>
